// extracted by mini-css-extract-plugin
export var body = "_gw-8";
export var button = "_gw-0";
export var closeButton = "_gw-5";
export var content = "_gw-3";
export var empty = "_gw-f";
export var grid = "_gw-c";
export var header = "_gw-4";
export var icon = "_gw-1";
export var option = "_gw-d";
export var optionSelected = "_gw-e";
export var overlay = "_gw-2";
export var searchIcon = "_gw-a";
export var searchInput = "_gw-b";
export var searchWrapper = "_gw-9";
export var title = "_gw-6";
export var visuallyHidden = "_gw-7";